import { combineReducers } from 'redux';
import SetupReducer from '../modules/setup/reducer';
import FeedbackReducer from './feedbackReducer';
import DialogReducer from '../modules/dialogs/reducer';
import LocalizationReducer from '../core/localization/reducer';
import DevicesReducer from '../modules/devices/reducer';
import OrdersReducer from '../modules/orders/reducer';
import DTypesReducer from '../modules/devicetypes/reducer';
import CustomersReducer from '../modules/customers/reducer';

export default combineReducers({
  setupState: SetupReducer,
  feedbackState: FeedbackReducer,
  localizationState: LocalizationReducer,
  devicesState: DevicesReducer,
  ordersState: OrdersReducer,
  deviceTypesState: DTypesReducer,
  customersState: CustomersReducer,
  dialogState: DialogReducer,
});
